import styled, { css } from 'styled-components';

import { ProductSliderPlaceholder } from '@notino/react-styleguide';

export const StyledListPlaceholder = styled(ProductSliderPlaceholder)<{
  newDesign: boolean;
}>`
  overflow-x: auto;

  ${({ newDesign }) =>
    newDesign &&
    css`
      margin: 1.5rem 0 4rem;
    `}
`;
